import { FETCH_PERSON_REGISTRATION_DATA } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(FETCH_PERSON_REGISTRATION_DATA);
export default addReducer;
